import {uniqueId} from 'lodash'

const routeToClientCard = {
  name: 'ContactCard',
  params: {
    id: 'id'
  },
  paramName: 'id',
  paramValue: 'clientId',
  props: true
}

const columns = [
  {
    title: 'DATE',
    type: 'date',
    prop: 'paymentDate',
    padding: true
  },
  {
    title: 'SERVICE NAME',
    prop: 'name'
  },
  {
    title: 'PROFORMA NO.',
    prop: 'number',
    hover: true,
    actionType: 'openProforma'
  },
  {
    title: 'CLIENT’S NAME',
    prop: 'clientNickName',
    route: routeToClientCard,
    hover: true
  },
  {
    title: 'AMOUNT',
    prop: 'amount',
    padding: true
  },
  {
    title: 'COMPLETION DATE',
    prop: 'approvedDate',
    type: 'date',
    padding: true,
    width: 'minmax(130px, 1fr)'
  }
]

const prefix = 'funds_kpi_column'
const fundsKPITableColumns = columns.map(col => {
  col.id = uniqueId(prefix)
  return col
})

export default fundsKPITableColumns



// WEBPACK FOOTER //
// ./src/constants/TablesOptions/fundsKPITable.js